<div class="ui segment">
  <div class="ui sub header" suiPopup [popupText]="diff.path">
    @switch (diff.op) {
      @case ("add") {
        <i class="plus icon"></i>
        <ng-container i18n="@@changelog-added">{{ path }} hinzugefügt</ng-container>
      }
      @case ("remove") {
        <i class="x icon"></i>
        <ng-container i18n="@@changelog-removed">{{ path }} entfernt</ng-container>
      }
      @case ("replace") {
        <i class="pencil icon"></i>
        <ng-container i18n="@@changelog-replaced">{{ path }} geändert</ng-container>
      }
    }
  </div>
  @if (descriptionDiff) {
    <div [innerHTML]="descriptionDiff"></div>
  } @else {
    @if (diff.before) {
      <s class="diff-removed" suiPopup [popupText]="diff.before | json">{{ displayBefore ?? diff.before }}</s>
    }
    @if (diff.before && diff.value) {
      <i class="right arrow icon"></i>
    }
    @if (diff.value) {
      <span class="diff-added" suiPopup [popupText]="diff.value | json">{{ displayValue ?? diff.value }}</span>
    }
  }
</div>
